import { useEffect } from 'react';

import useCooperativeId from 'shared/hooks/useCooperativeId';

import { keyOrdersApi } from '../../api';
import { fileLoaderApi, EntityType } from 'features/file-loader';

type Options = {
  caseId: string;
};

export const useQueryState = ({ caseId }: Options) => {
  const cooperativeId = useCooperativeId();

  const [getKeyOrderCase, getKeyOrderCaseQueryState] =
    keyOrdersApi.useLazyGetKeyOrderCaseQuery();
  const [getAttachments, getAttachmentsQueryState] =
    fileLoaderApi.useLazyGetAttachmentsQuery();

  useEffect(() => {
    getKeyOrderCase(caseId);
  }, [caseId]);

  useEffect(() => {
    if (cooperativeId) {
      getAttachments({
        cooperativeId,
        entityId: caseId,
        entityType: EntityType.Incident,
        cached: true,
      });
    }
  }, [cooperativeId, caseId]);

  return { getKeyOrderCaseQueryState, getAttachmentsQueryState };
};

export default useQueryState;
